import { Field, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
export class HaulerSignature {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  name?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  base64Signature?: string

  @Field(() => Date, { nullable: true })
  @Prop({ type: Date })
  dateCreated?: Date

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  signatureUrl?: string
}
